import styled from 'styled-components'
import { CollectionTextSection } from '../../CollectionTextSection/CollectionTextSection'
import { ResponsiveImage } from '../../ResponsiveImage/ResponsiveImage'

export const BlocksGrid = styled.div`
  display: flex;
  gap: 0.8rem;
  flex-direction: column;

  & > div {
    &:nth-child(2) {
      grid-area: LookbookBlockItem0;
    }

    &:nth-child(3) {
      grid-area: LookbookBlockItem1;
    }
  }

  @media screen and (min-width: 768px) {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: 1fr 1fr;
    grid-auto-flow: row;
    grid-template-areas:
      'LookbookBlockItem0 TextBlock'
      'LookbookBlockItem0 LookbookBlockItem1';
  }
`

export const StyledResponsiveImage = styled(ResponsiveImage)`
  height: 100%;
  object-fit: cover;
`

export const TextBlock = styled(CollectionTextSection)`
  margin: 0 auto;
  padding: 3rem;
  grid-area: TextBlock;
`
